import { BehaviorSubject } from "rxjs";

class DrawerManager {
    public visible$ = new BehaviorSubject<boolean>(false);

    drawerShow(): void {
        this.visible$.next(true);
    }

    drawerHide(): void {
        this.visible$.next(false);
    }
}

export default DrawerManager;
